import Aurelia, { CustomElement } from 'aurelia';
import { MyApp } from './my-app';
import {
  WaterRipple,
  IdleAnimationDirectorAttribute,
  Release,
  AppHeader,
  AdminMenu,
  AccountMenu,
  AppFooter,
  FilterPanel,
  AdminLog,
  CalendarGrid,
  ReleasesPanel,
  Lightbox,
  LoginModal,
  LegalModal,
  SaveSearchModal,
  ProfileModal,
  EmailOptInModal,
  WelcomeModal,
  SignupNudge,
  SubscriptionLimitToast,
  FeedbackWidget,
  SourceAdminPanel,
  ImageCacheAdminPanel,
  UsersReportAdminPanel,
  ScraperReportAdminPanel,
  DailyReleasesAdminPanel
} from './components';
import { ConfigAdminPanel, LogsAdminPanel, AnalyticsAdminPanel } from './components';
import template from './my-app.html';
import './styles.css';

const MyAppDef = CustomElement.define({ name: 'my-app', template }, MyApp);
const host = document.querySelector<HTMLElement>('my-app')!;
Aurelia.register(
  WaterRipple,
  IdleAnimationDirectorAttribute,
  Release,
  AppHeader,
  AdminMenu,
  AccountMenu,
  AppFooter,
  FilterPanel,
  AdminLog,
  CalendarGrid,
  ReleasesPanel,
  Lightbox,
  LoginModal,
  LegalModal,
  SaveSearchModal,
  ProfileModal,
  EmailOptInModal,
  WelcomeModal,
  SignupNudge,
  SubscriptionLimitToast,
  FeedbackWidget,
  SourceAdminPanel,
  ImageCacheAdminPanel,
  UsersReportAdminPanel,
  ScraperReportAdminPanel,
  DailyReleasesAdminPanel,
  ConfigAdminPanel,
  LogsAdminPanel,
  AnalyticsAdminPanel
).app({ host, component: MyAppDef }).start();
